import React from 'react';
import * as ExcelJS from 'exceljs';
import { Bounce, toast } from 'react-toastify';
import { IconButton, Tooltip } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { cartReducer } from '../redux/features/listSlice';
import { useDispatch } from 'react-redux';

const ExcelDownloadButton = ({ data, filename,handleClose }) => {
    const dispatch = useDispatch()
    const [fileData,setFileData] = React.useState([])

React.useEffect(()=>{
    if(data.length > 0){
        const restData = data.map((r) => {
            return {
              "Center Name":r?.centre_name ||'',
              "Lab Name" : r?.test_centre || '',
                "Test Code": r?.test_code || '',
                "Test Name": r?.test_name || '',
                // "Package Id": r?.package_id || '',
                // "Package Name": r?.packagename || '',
                "Methodology": r?.methodology || '',
                "Price": r?.mrp || '',
                "Tat": r?.tat,
                "Lab Name": r?.centre_name || '',
                "Category": r?.category || '',
                "Specimen Remarks": r?.specimen_remarks || '',
                "Sample Type": r?.sampleType_name || '',
                "Frequency": r?.frequency || '',
                "Temperature": r?.temp || '',
                "Container": r?.container || '',
                "Cutt Off": r?.cut_off || '',
                "Disease Name": r?.disease_name || ''
            }
        });
        setFileData(restData);
      
    }else{
        setFileData([])
    }
},[data])

  const downloadExcelFile = async () => {
    if(fileData.length >0 ){
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');
    
        // Add headers
        const headers = Object.keys(fileData[0]);
        worksheet.addRow(headers);
    
        // Add data rows
        fileData.forEach(row => {
          const values = headers.map(header => row[header]);
          worksheet.addRow(values);
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
        const url = URL.createObjectURL(blob);
    
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'data.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        sessionStorage.removeItem("cartValues")
        // dispatch(cartReducer([]))
        handleClose()
    }else{
        toast.warn("No data availbale",{
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition:Bounce
          })
    }
  
  };

  return (
             <Tooltip
               title={"Download as excel"}
                placement="top-start">
                <IconButton onClick={()=>downloadExcelFile()}>
                  <DownloadIcon/>
                </IconButton>
              </Tooltip> 
  );
};

export default ExcelDownloadButton;
